export const DEFAULT_SESSION_INACTIVITY_MINUTES = 25;
export const MIN_SESSION_INACTIVITY_MINUTES = 5;
export const SESSION_INACTIVITY_CHECK_MS = 30_000;

export function resolveInactivityMs(rawMinutes = process.env.REACT_APP_SESSION_INACTIVITY_MINUTES) {
  const minutes = rawMinutes != null ? Number(rawMinutes) : DEFAULT_SESSION_INACTIVITY_MINUTES;
  if (!Number.isFinite(minutes) || minutes < MIN_SESSION_INACTIVITY_MINUTES) {
    return DEFAULT_SESSION_INACTIVITY_MINUTES * 60 * 1000;
  }
  return minutes * 60 * 1000;
}
